import React from 'react';

function About() {
  return (
    <section id="about" className="about">
      <div className="section-inner">
        <h2 className="section-title">
          <span className="title-emerald">About</span> <span className="title-gold">us</span>
        </h2>
        <p className="about-intro">
          Welcome to Emerald Horizon – Redefining Modern Living Spaces.
        </p>
        <div className="about-content">
          <p className="about-text">
            We specialize in fully bespoke interior and exterior transformations, bridging the gap between artisan craftsmanship and functional luxury. Our mission is simple: to take any living space and turn it into a sleek, elegant masterpiece.
          </p>
          <p className="about-text">
            From the heart of the home to the curb appeal of your driveway, we provide seamless design solutions tailored to your unique style. We are experts in hand-crafted resin countertops and flooring, offering the timeless beauty of marble with superior durability. Our polished plaster finishes and custom media walls add depth and sophistication to any room, while our landscaping and resin-bound exterior services ensure your property is breathtaking from the outside in. Whether you desire a high-gloss marble effect or a contemporary matte finish, we bring your vision to life with precision and flair.
          </p>
        </div>
        <div className="about-cta-block">
          <h3 className="about-cta-title">Visualize the Extraordinary</h3>
          <p className="about-cta-text">
            At Emerald Horizon, we understand that renovations can be challenging. To eliminate the guesswork, we invite you to contact our bespoke interior design team for a free, computer-aided mockup of your living space. Utilizing the latest visualization technology, we supply you with a hyper-realistic preview of the finished job before we lift a finger. This ensures complete alignment with your vision and guarantees customer satisfaction with every project.
          </p>
          <a
            href="#contact"
            className="about-cta-link"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            Get your free mockup
          </a>
        </div>
      </div>
    </section>
  );
}

export default About;
